import Helpers from '../modules/Helpers'
import IsNodeList from './IsNodeList'

class Reveal {
    constructor(element) {
        // Ensure whatever element is passed into the
        // constructor is an array, as methods loop
        // over every element using `forEach`.
        if (Array.isArray(element)) {
            this.element = element
        } else if (!IsNodeList(element)) {
            this.element = [element]
        } else {
            this.element = Array.from(element)
        }
    }


    /**
     * 'Show' element by adding class to element
     * and setting `aria-expanded` value to 'true'
     * 
     * @param  {String} className Class name to add to element
     * @return {Object}
     */
    show(className) {
        this.element.forEach((element) => {
            new Helpers(element).addClass(className)
            element.setAttribute('aria-expanded', 'true')
        })

        return this
    }

    /**
     * 'Hide' element by removing class on element
     * and setting `aria-expanded` value to 'false'
     * 
     * @param  {String} className Class name to remove from element
     * @return {Object}
     */
    hide(className) {
        this.element.forEach((element) => {
            new Helpers(element).removeClass(className)
            element.setAttribute('aria-expanded', 'false')
        })

        return this
    }

    /**
     * 'Toggle' element by adding and removing class on element
     * and changing `aria-expanded` value to either 'true' or
     * 'false' depending on current value.
     * 
     * @param  {String} className Class name to toggle on element
     * @return {Object}
     */
    toggle(className) {
        this.element.forEach((element) => {
            new Helpers(element)
                .toggleClass(className)
                .toggleAttribute('aria-expanded')
        })

        return this
    }
}

export default Reveal
